import React from "react";

const COLS = "grid-cols-[22px_1fr_18px_18px_18px_18px_28px_30px]";

// Final league standings; the player's row is highlighted.
const LeagueTable = ({ rows }) => (
  <div data-testid="league-table" className="rounded-xl border border-white/10 overflow-hidden">
    <div className={`grid ${COLS} gap-1 px-2 py-1.5 text-[10px] text-muted-38 font-semibold bg-white/5`}>
      <span>#</span>
      <span>Club</span>
      <span className="text-center">P</span>
      <span className="text-center">W</span>
      <span className="text-center">D</span>
      <span className="text-center">L</span>
      <span className="text-center">GD</span>
      <span className="text-center">Pts</span>
    </div>
    <div className="max-h-[360px] overflow-y-auto">
      {rows.map((r) => (        <div
          key={r.short + r.pos}
          data-testid={r.isPlayer ? "league-row-player" : undefined}
          className={`grid ${COLS} gap-1 px-2 py-1.5 items-center text-[11px] border-t border-white/5 ${
            r.isPlayer ? "bg-[#10B981]/15" : r.relegated ? "bg-red-500/10" : ""
          }`}
        >
          <span className={`font-semibold ${r.relegated ? "text-red-400" : "text-muted-38"}`}>{r.pos}</span>
          <span className="flex items-center gap-1.5 min-w-0">
            <span
              className="w-4 h-4 rounded flex items-center justify-center text-[7px] font-bold text-white shrink-0"
              style={{ backgroundColor: r.color }}
            >
              {r.short}
            </span>
            <span className={`truncate ${r.isPlayer ? "font-bold text-[#10B981]" : "text-slate-200"}`}>{r.name}</span>
          </span>
          <span className="text-center text-muted-38">{r.played}</span>
          <span className="text-center">{r.w}</span>
          <span className="text-center">{r.d}</span>
          <span className="text-center">{r.l}</span>
          <span className="text-center">{r.gd > 0 ? `+${r.gd}` : r.gd}</span>
          <span className="text-center font-bold text-white">{r.points}</span>
        </div>
      ))}
    </div>
  </div>
);

export default LeagueTable;
